export const categorySites: Record<string, {
  id: string;
  name: string;
  url: string;
  rating: number;
  tags: string[];
  description: string;
  logoUrl: string;
}[]> = {
  movie: [
    {
      id: 'movie-1',
      name: '星辰影院',
      url: 'https://wfsqdz.cn/xingchen',
      rating: 4.8,
      tags: ['高清画质', '更新快速', '无广告'],
      description: '国内领先的免费在线观影平台，提供超清1080P画质，每日更新热门电影和电视剧资源，支持多线路切换，播放流畅不卡顿。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20golden%20star%20logo%20design%20on%20warm%20cream%20background%2C%20elegant%20cinema%20platform%20brand%20identity%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20professional%20and%20trustworthy%20feel&width=200&height=200&seq=cat-movie-01&orientation=squarish',
    },
    {
      id: 'movie-2',
      name: '飞鱼影视',
      url: 'https://wfsqdz.cn/feiyu',
      rating: 4.4,
      tags: ['新片速递', '多线路', '无需注册'],
      description: '无需注册即可免费观看最新电影大片，提供多条播放线路自动切换，画质从标清到4K随心选择，观影零门槛。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20flying%20fish%20silhouette%20logo%20on%20warm%20cream%20background%2C%20elegant%20streaming%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20dynamic%20and%20modern%20feel&width=200&height=200&seq=cat-movie-02&orientation=squarish',
    },
    {
      id: 'movie-3',
      name: '光速影视',
      url: 'https://wfsqdz.cn/guangsu',
      rating: 4.6,
      tags: ['4K超清', '杜比音效', '会员免费'],
      description: '主打4K超清画质的在线影院，支持杜比环绕音效，提供沉浸式观影体验。片库涵盖全球最新大片，影迷必备收藏网站。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20lightning%20bolt%20logo%20on%20warm%20cream%20background%2C%20elegant%20cinema%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20modern%20and%20speedy%20feel&width=200&height=200&seq=cat-movie-03&orientation=squarish',
    },
    {
      id: 'movie-4',
      name: '天龙影院',
      url: 'https://wfsqdz.cn/tianlong',
      rating: 4.3,
      tags: ['经典老片', '午夜场', '专题推荐'],
      description: '拥有丰富的经典老片资源库，从好莱坞黄金时代到香港电影巅峰期，适合怀旧影迷。每周推出特色专题，发掘被遗忘的好电影。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20dragon%20silhouette%20logo%20on%20warm%20cream%20background%2C%20elegant%20classic%20cinema%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20timeless%20and%20noble%20feel&width=200&height=200&seq=cat-movie-04&orientation=squarish',
    },
  ],
  series: [
    {
      id: 'series-1',
      name: '极光影城',
      url: 'https://wfsqdz.cn/jiguang',
      rating: 4.7,
      tags: ['海量资源', '蓝光画质', '中文字幕'],
      description: '拥有海量影视资源库，涵盖国内外热门电影、电视剧、综艺节目，支持蓝光画质播放，提供精准中文字幕，观影体验极佳。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20aurora%20light%20logo%20icon%20on%20warm%20cream%20background%2C%20elegant%20cinema%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20modern%20and%20premium%20feel&width=200&height=200&seq=cat-series-01&orientation=squarish',
    },
    {
      id: 'series-2',
      name: '星河TV',
      url: 'https://wfsqdz.cn/xinghe',
      rating: 4.3,
      tags: ['美剧韩剧', '日剧泰剧', '双语字幕'],
      description: '海外剧集爱好者的首选平台，涵盖美剧、韩剧、日剧、泰剧等热门资源，提供双语字幕，追剧体验一流。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20galaxy%20spiral%20logo%20on%20warm%20cream%20background%2C%20elegant%20global%20streaming%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20cosmopolitan%20and%20premium%20feel&width=200&height=200&seq=cat-series-02&orientation=squarish',
    },
    {
      id: 'series-3',
      name: '追剧达人',
      url: 'https://wfsqdz.cn/zhuiju',
      rating: 4.5,
      tags: ['内地剧', '港台剧', '自动连播'],
      description: '专注华语剧集的追剧平台，囊括内地热门剧、港剧经典、台剧精品。支持自动连播功能，追剧不停歇，一口气看完不是梦。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20play%20button%20logo%20on%20warm%20cream%20background%2C%20elegant%20drama%20streaming%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20cozy%20and%20inviting%20feel&width=200&height=200&seq=cat-series-03&orientation=squarish',
    },
  ],
  variety: [
    {
      id: 'variety-1',
      name: '蓝鲸影视',
      url: 'https://wfsqdz.cn/lanjing',
      rating: 4.6,
      tags: ['综艺齐全', '实时更新', '弹幕互动'],
      description: '专注综艺节目和纪录片的优质平台，实时同步更新各大卫视热门综艺，支持弹幕互动功能，让观看体验更加有趣。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20blue%20whale%20silhouette%20logo%20on%20warm%20cream%20background%2C%20elegant%20entertainment%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20friendly%20and%20modern%20feel&width=200&height=200&seq=cat-variety-01&orientation=squarish',
    },
    {
      id: 'variety-2',
      name: '综艺大全',
      url: 'https://wfsqdz.cn/zongyi',
      rating: 4.2,
      tags: ['卫视同步', '往期回看', '花絮合集'],
      description: '囊括所有主流卫视综艺节目，与电视同步更新，错过直播也能随时回看。更有独家花絮和未播片段，综艺迷不可错过。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20stage%20spotlight%20logo%20on%20warm%20cream%20background%2C%20elegant%20variety%20show%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20lively%20and%20fun%20feel&width=200&height=200&seq=cat-variety-02&orientation=squarish',
    },
  ],
  anime: [
    {
      id: 'anime-1',
      name: '樱花动漫',
      url: 'https://wfsqdz.cn/yinghua',
      rating: 4.5,
      tags: ['日漫美漫', '国漫专区', '高清无删减'],
      description: '动漫爱好者的天堂，提供海量日本动漫、美国动漫及国产动漫资源，高清无删减版本，更新速度业界领先。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cherry%20blossom%20petal%20logo%20on%20warm%20cream%20background%2C%20elegant%20anime%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20playful%20yet%20sophisticated%20feel&width=200&height=200&seq=cat-anime-01&orientation=squarish',
    },
    {
      id: 'anime-2',
      name: '次元动漫',
      url: 'https://wfsqdz.cn/ciyuan',
      rating: 4.4,
      tags: ['新番速递', '弹幕吐槽', '追番日历'],
      description: '二次元爱好者的聚集地，新番更新速度极快，支持弹幕吐槽互动。内置追番日历功能，再也不会错过喜欢的番剧更新。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20portal%20gate%20logo%20on%20warm%20cream%20background%2C%20elegant%20anime%20streaming%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20magical%20and%20fun%20feel&width=200&height=200&seq=cat-anime-02&orientation=squarish',
    },
  ],
  documentary: [
    {
      id: 'doc-1',
      name: '纪实频道',
      url: 'https://wfsqdz.cn/jishi',
      rating: 4.5,
      tags: ['BBC纪录片', '国家地理', '探索频道'],
      description: '专注高品质纪录片的在线平台，涵盖BBC、国家地理、探索频道等顶级纪录片资源，涵盖自然、历史、科技等多元主题。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20compass%20logo%20on%20warm%20cream%20background%2C%20elegant%20documentary%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20exploratory%20and%20trustworthy%20feel&width=200&height=200&seq=cat-doc-01&orientation=squarish',
    },
    {
      id: 'doc-2',
      name: '知识影库',
      url: 'https://wfsqdz.cn/zhishi',
      rating: 4.3,
      tags: ['人文历史', '科学探索', '自然风光'],
      description: '将知识与影像完美结合的纪录片平台，精选全球优质人文、科学、自然类纪录片，让您在观影中增长见识，开阔视野。',
      logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20open%20book%20logo%20on%20warm%20cream%20background%2C%20elegant%20knowledge%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20scholarly%20and%20warm%20feel&width=200&height=200&seq=cat-doc-02&orientation=squarish',
    },
  ],
};